(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article__slideshow"] && !Shopify.designMode) return;
  try {
     
  function FeaturedCollection (container) {
    let collectionProductSliderConfig = {
      arrowShape: { x0: 10, x1: 60, y1: 50, x2: 75, y2: 35, x3: 40 },
      cellAlign: "center",
      contain: true,
      groupCells: "100%",
      imagesLoaded: true,
      pageDots: false,
      resize: true,
      draggable: true,
      prevNextButtons: true,
      adaptiveHeight: false,
      wrapAround: false,
      lazyLoad: true
    }
    this.init(container, collectionProductSliderConfig);
  }
  
  FeaturedCollection.prototype = {
    init: function(container, config){     
      this.slideContainer = document.querySelectorAll('.featured-collection__loop--slider-true');      
      this.sliderConfig = config;
      this.slideContainer.forEach(function(e){
        this.buildSlider(e, this.sliderConfig);   
      }.bind(this));
      this.initEvents();
    },
    buildSlider: function(container, config){
      return new Flickity(container, config);
    },
    resizeSlider: function(slider){
      if(slider){
        slider.resize();
      }
    },
    initEvents: function(){
      events.on('resize', '*', function(event){
        this.resizeSlider(this.collectionProductSlider)
      }.bind(this))
    },
  }
  
  const featuredCollection = {
    runFeaturedCollection: function(container){
      let slider = new FeaturedCollection(container)
    }
  }

  window.theme = window.theme || {};
  window.theme.scripts = window.theme.scripts || {};
  window.theme.scripts.featured_collection = window.theme.scripts.featured_collection || {};
  window.theme.scripts.featured_collection.init = featuredCollection.runFeaturedCollection;

  window.theme.scripts.featured_collection.init();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog__article-slideshow"] && !Shopify.designMode) return;
  try {
     
function getDistanceBetweenPoints(lat1, lng1, lat2, lng2) {
  const earthRadius = 3958.8; // miles
  const radianLat1 = degreesToRadians(lat1);
  const radianLat2 = degreesToRadians(lat2);
  const deltaLat = degreesToRadians(lat2 - lat1);
  const deltaLng = degreesToRadians(lng2 - lng1);
  const a = Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
    Math.cos(radianLat1) * Math.cos(radianLat2) *
    Math.sin(deltaLng / 2) * Math.sin(deltaLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = earthRadius * c;
  return distance;
}

function degreesToRadians(degrees) {
  return degrees * (Math.PI / 180);
}

  window.onload = function() {
    var winLoc = window.loc;
    var tag = "fishing-in-"+window.ipRegionAbbrev;
    var xhr = new XMLHttpRequest();
    xhr.open("GET", "/blogs/where-to-fish/tagged/" + tag + "?view=ajax", true);
    xhr.responseType = "json";
    xhr.onload = function() {
      if (xhr.status === 200) {
        var articles = xhr.response.articles;
      
        var limit = window.articleLimit;
        var articleHTML = "";

        // Calculate distances for all articles
        articles.forEach(function (article) {
          article.distance = getDistanceBetweenPoints(winLoc[0], winLoc[1], article.tags_loc[0], article.tags_loc[1]).toFixed(2);
        });

        // Sort articles by distance
        articles.sort(function (a, b) {
          return parseFloat(a.distance) - parseFloat(b.distance);
        });

        for (var i = 0; i < limit; i++) {
          var article = articles[i];
          var dist = article.distance;
          articleHTML += '<div class="blog__card-wrapper featured-collection__product featured-collection__product--'+articlesToShow+' featured-collection__product--slider featured-collection__1--slider-true--image-">';
          articleHTML += '<div class="blog-card card-background card-shadow">';          
          articleHTML += '<div class="product-loop-element">';
          articleHTML += "<div class='blog-copy'>";
          articleHTML += '<p class="blog__article-label p--small p--uppercase p-link--no-accent p--extra-small p--bold pb-8">'+window.ipRegion+'</p>';
          articleHTML += "<div class='blog__article-header'>"
          articleHTML += "<a href='/blogs/where-to-fish/"+article.handle+"'>";
          articleHTML += "<h3 class='h4 blog__article-title blog__article-title--card'>" + article.title + "</a></h3>";
          articleHTML += "</a>";
          articleHTML += "</div>";
          articleHTML += '<p class="p--small text--no-margin">'+dist+' miles from your location</p>';
          articleHTML += "<a href='/blogs/where-to-fish/"+article.handle+"'>";
          articleHTML += '<span class="btn">LEARN MORE</span>';
          articleHTML += "</a>";
          articleHTML += "</div></div></div></div></div>";      
        }
        document.getElementById("articles").innerHTML = articleHTML;
        document.getElementById("articles").classList.add('featured-collection__loop--slider-true')
        window.theme.scripts.featured_collection.init(document)
        //document.body.innerHTML = document.body.innerHTML.replace("[PLACE]", window.ipCity);
  
          //document.body.innerHTML = document.body.innerHTML.replace("TOP WATERS NEAR", "TOP WATERS NEAR " + window.ipCity +","+ window.ipRegion + "");
          document.getElementById("dynamic-location").innerText = "TOP WATERS NEAR " + window.ipCity +","+ window.ipRegion + "";
    
     }
    };
    xhr.send();
  };
   function FeaturedCollection (container) {
    let collectionProductSliderConfig = {
      arrowShape: { x0: 10, x1: 60, y1: 50, x2: 75, y2: 35, x3: 40 },
      cellAlign: "center",
      contain: true,
      groupCells: "100%",
      imagesLoaded: true,
      pageDots: false,
      resize: true,
      draggable: true,
      prevNextButtons: true,
      adaptiveHeight: false,
      wrapAround: false,
      lazyLoad: true
    }
    this.init(container, collectionProductSliderConfig);
  }
  
  FeaturedCollection.prototype = {
    init: function(container, config){     
      this.slideContainer = document.querySelectorAll('.featured-collection__loop--slider-true');      
      this.sliderConfig = config;
      this.slideContainer.forEach(function(e){
        this.buildSlider(e, this.sliderConfig);   
      }.bind(this));
      this.initEvents();
    },
    buildSlider: function(container, config){
      return new Flickity(container, config);
    },
    resizeSlider: function(slider){
      if(slider){
        slider.resize();
      }
    },
    initEvents: function(){
      events.on('resize', '*', function(event){
        this.resizeSlider(this.collectionProductSlider)
      }.bind(this))
    },
  }
  
  const featuredCollection = {
    runFeaturedCollection: function(container){
      let slider = new FeaturedCollection(container)
    }
  }

  window.theme = window.theme || {};
  window.theme.scripts = window.theme.scripts || {};
  window.theme.scripts.featured_collection = window.theme.scripts.featured_collection || {};
  window.theme.scripts.featured_collection.init = featuredCollection.runFeaturedCollection;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /*!
   * eventslibjs v1.2.0
   * A tiny event delegation helper library.
   * (c) 2019 Chris Ferdinandi
   * MIT License
   * http://github.com/cferdinandi/events
   */
  
   (function (root, factory) {
    if ( typeof define === 'function' && define.amd ) {
      define([], (function () {
        return factory(root);
      }));
    } else if ( typeof exports === 'object' ) {
      module.exports = factory(root);
    } else {
      root.events = factory(root);
    }
  })(typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : this, (function (window) {
  
    'use strict';
  
    //
    // Variables
    //
  
    var publicAPIs = {};
    var activeEvents = {};
  
  
    //
    // Methods
    //
  
    /**
     * Get the index for the listener
     * @param  {Array}   arr      The listeners for an event
     * @param  {Array}   listener The listener details
     * @return {Integer}          The index of the listener
     */
    var getIndex = function (arr, selector, callback) {
      for (var i = 0; i < arr.length; i++) {
        if (
          arr[i].selector === selector &&
          arr[i].callback.toString() === callback.toString()
        ) return i;
      }
      return -1;
    };
  
    /**
     * Check if the listener callback should run or not
     * @param  {Node}         target   The event.target
     * @param  {String|Node}  selector The selector to check the target against
     * @return {Boolean}               If true, run listener
     */
    var doRun = function (target, selector) {
      if ([
        '*',
        'window',
        'document',
        'document.documentElement',
        window,
        document,
        document.documentElement
      ].indexOf(selector) > -1) return true;
      if (typeof selector !== 'string' && selector.contains) {
        return selector === target || selector.contains(target);
      }
      return target.closest(selector);
    };
  
    /**
     * Handle listeners after event fires
     * @param {Event} event The event
     */
    var eventHandler = function (event) {
      if (!activeEvents[event.type]) return;
      activeEvents[event.type].forEach((function (listener) {
        if (!doRun(event.target, listener.selector)) return;
        listener.callback(event);
      }));
    };
  
    /**
     * Add an event
     * @param  {String}   types    The event type or types (comma separated)
     * @param  {String}   selector The selector to run the event on
     * @param  {Function} callback The function to run when the event fires
     */
    publicAPIs.on = function (types, selector, callback) {
  
      // Make sure there's a selector and callback
      if (!selector || !callback) return;
  
      // Loop through each event type
      types.split(',').forEach((function (type) {
  
        // Remove whitespace
        type = type.trim();
  
        // If no event of this type yet, setup
        if (!activeEvents[type]) {
          activeEvents[type] = [];
          window.addEventListener(type, eventHandler, true);
        }
  
        // Push to active events
        activeEvents[type].push({
          selector: selector,
          callback: callback
        });
  
      }));
  
    };
  
    /**
     * Remove an event
     * @param  {String}   types    The event type or types (comma separated)
     * @param  {String}   selector The selector to remove the event from
     * @param  {Function} callback The function to remove
     */
    publicAPIs.off = function (types, selector, callback) {
  
      // Loop through each event type
      types.split(',').forEach((function (type) {
  
        // Remove whitespace
        type = type.trim();
  
        // if event type doesn't exist, bail
        if (!activeEvents[type]) return;
  
        // If it's the last event of it's type, remove entirely
        if (activeEvents[type].length < 2 || !selector) {
          delete activeEvents[type];
          window.removeEventListener(type, eventHandler, true);
          return;
        }
  
        // Otherwise, remove event
        var index = getIndex(activeEvents[type], selector, callback);
        if (index < 0) return;
        activeEvents[type].splice(index, 1);
  
      }));
  
    };
  
    /**
     * Add an event, and automatically remove it after it's first run
     * @param  {String}   types    The event type or types (comma separated)
     * @param  {String}   selector The selector to run the event on
     * @param  {Function} callback The function to run when the event fires
     */
    publicAPIs.once = function (types, selector, callback) {
      publicAPIs.on(types, selector, (function temp (event) {
        callback(event);
        publicAPIs.off(types, selector, temp);
      }));
    };
  
    /**
     * Get an immutable copy of all active event listeners
     * @return {Object} Active event listeners
     */
    publicAPIs.get = function () {
      var obj = {};
      for (var type in activeEvents) {
        if (activeEvents.hasOwnProperty(type)) {
          obj[type] = activeEvents[type];
        }
      }
      return obj;
    };
  
  
    //
    // Return public APIs
    //
  
    return publicAPIs;
  
  }));
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-featured-collection"] && !Shopify.designMode) return;
  try {
    
function FeaturedCollection (container) {
  let collectionProductSliderConfig = {
    arrowShape: { x0: 10, x1: 60, y1: 50, x2: 75, y2: 35, x3: 40 },
    cellAlign: "center",
    contain: true,
    groupCells: "100%",
    imagesLoaded: true,
    pageDots: false,
    resize: true,
    draggable: true,
    prevNextButtons: true,
    adaptiveHeight: false,
    wrapAround: false,
    lazyLoad: true
  }

  this.init(container, collectionProductSliderConfig);
}

FeaturedCollection.prototype = {
  init: function(container, config){
    this.slideContainer = container.querySelector('.featured-collection__loop--slider-true');
    this.sliderConfig = config;
    this.collectionProductSlider = this.buildSlider(this.slideContainer, this.sliderConfig);
    this.initEvents();
  },
  buildSlider: function(container, config){
    return new Flickity(container, config);
  },
  resizeSlider: function(slider){
    slider.viewport.style.height = "";
    if(slider){
      slider.resize();
    }
  },
  initEvents: function(){
    events.on('resize', '*', function(event){
      this.resizeSlider(this.collectionProductSlider)
    }.bind(this))
  },
}

const featuredCollection = {
  runFeaturedCollection: function(container){
    let slider = new FeaturedCollection(container)
  }
}

window.theme = window.theme || {};
window.theme.scripts = window.theme.scripts || {};
window.theme.scripts.featured_collection = window.theme.scripts.featured_collection || {};
window.theme.scripts.featured_collection.init = featuredCollection.runFeaturedCollection;


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-gallery"] && !Shopify.designMode) return;
  try {
    
  theme.Site = theme.Site || {};

  function GallerySection (container){
    this.galleryContainer = container.querySelector(".gallery");
    this.galleryBlocks = this.galleryContainer.querySelectorAll(".grid-item");
    this.heightElement = this.galleryContainer.querySelector(".grid__height");
    this.margin = this.galleryContainer.querySelector(".grid__gutter");

    this.settings = {
      itemSelector: ".grid-item", 
      columnWidth: ".grid__size", 
      gutter: ".grid__gutter",
      horizontalOrder: false,
      percentPosition: true
    }
    
    this.videos = container.querySelectorAll('.video-player');

    if(this.videos.length > 0){
      theme.Site._initVideo()
    }
    this.init();
  }

  GallerySection.prototype = {
    init: function(){
      this.msnry = new Masonry(this.galleryContainer, this.settings);
      this._setBlockHeight(this.galleryBlocks);
      this.msnry.layout();
      this._initEvents();
    },
    _initEvents: function(){
      events.on('resize', '*', function(){
        this._resize();
      }.bind(this))
    },
    _resize: function(){
      this._setBlockHeight(this.galleryBlocks);
    },
    _setBlockHeight: function(blocks) {
      var gridHeight = this.heightElement.offsetHeight;
      var heightModifier = 30;
      var gridMargin = this.margin.offsetHeight;
      var blockHeights = [];


      if (window.innerWidth >= 769) {

        blocks.forEach(function(block){
          var blockDetails = {};
          blockDetails.block = block;
          blockDetails.height = block.offsetHeight;
          blockDetails.naturalHeight = block.querySelector('.gallery__text').offsetHeight;
          let blockCanExpand = false;
          let blockHeightModifier = 1;
          if(block.hasAttribute('data-gallery-expand')){
            blockCanExpand = true;
          }
          if(block.hasAttribute('data-desktop-height-mod')){
            blockHeightModifier = parseFloat(block.getAttribute('data-desktop-height-mod'));
          }

          if (block.classList.contains('desktop-small-square')){
            var newHeight = gridHeight; 
          } else if (block.classList.contains('desktop-tall-rectangle')){
            var newHeight = gridHeight * 2 + gridMargin;
          } else if (block.classList.contains('desktop-wide-rectangle') ){
            var newHeight = gridHeight;
          } else if (block.classList.contains('desktop-large-square')){
            var newHeight = gridHeight * 2 + gridMargin;
          } 

          if(blockCanExpand && blockDetails.naturalHeight > newHeight){
            blockDetails.newHeight = blockDetails.naturalHeight * blockHeightModifier;
          } else {
            blockDetails.newHeight = newHeight * blockHeightModifier;
          }
          blockHeights.push(blockDetails);

        })
      } else {
        blocks.forEach(function(block){
          var blockDetails = {};
          blockDetails.block = block;
          blockDetails.height = block.offsetHeight;
          blockDetails.naturalHeight = block.querySelector('.gallery__text').offsetHeight;
          let blockCanExpand = false;
          let blockHeightModifier = 1;
          if(block.hasAttribute('data-gallery-expand')){
            blockCanExpand = true;
          }

          if(block.hasAttribute('data-mobile-height-mod')){
            blockHeightModifier = parseFloat(block.getAttribute('data-mobile-height-mod'));
          }

          if (block.classList.contains('grid-item--mobile-small-square')){
            var newHeight = gridHeight; 
          } else if (block.classList.contains('grid-item--mobile-tall-rectangle')){
            var newHeight = gridHeight * 2 + gridMargin;
          }else if (block.classList.contains('grid-item--mobile-wide-rectangle') ){
            var newHeight = gridHeight;
          } else if (block.classList.contains('grid-item--mobile-large-square')){
            var newHeight = gridHeight * 2 + gridMargin;
          }
          if(blockCanExpand && blockDetails.naturalHeight > newHeight){
            blockDetails.newHeight = blockDetails.naturalHeight * blockHeightModifier;
          } else {
            blockDetails.newHeight = newHeight * blockHeightModifier;
          }
          blockHeights.push(blockDetails);
        })
      }
      blockHeights.forEach(function(element){
        element.block.style.paddingTop = '0px';
        element.block.style.paddingTop = element.newHeight + "px";
      })     
    }
  }
  const galleryActions = {
    runGallery: function(container){
      let gallery = new GallerySection(container)
    }
  }
  
  window.theme = window.theme || {};
  window.theme.scripts = window.theme.scripts || {};
  window.theme.scripts.gallery = window.theme.scripts.gallery || {};
  window.theme.scripts.gallery.init = galleryActions.runGallery;
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-logo-list"] && !Shopify.designMode) return;
  try {
    


function LogoList (container) {
  this.logolistConfig = {
    arrowShape: { x0: 10, x1: 60, y1: 50, x2: 75, y2: 35, x3: 40 },
    cellAlign: "left",
    lazyLoad: false,
    freeScroll: false,
    groupCells: "100%",
    pageDots: false,
    contain: true 
  },

  this.sectionContainer = container;
  this.slideContainer = this.sectionContainer.querySelector('.logo-list');
  this.sliderEnabled = this.slideContainer.getAttribute('data-slider');

  this.init();
};

LogoList.prototype = {
  init: function(){
    this._initEvents();
    if(this.sliderEnabled === 'true'){
      this.buildLogoSlider(this.slideContainer, this.logolistConfig);
    }
  },
  _initEvents: function(){

  },
  buildLogoSlider: function(container, config){
    return new Flickity(container, config);
  },
  _resize: function(){

  },
};

const logolistActions = {
  runLogolist: function(container){
    let logolist = new LogoList(container)
  }
}

window.theme = window.theme || {};
window.theme.scripts = window.theme.scripts || {};
window.theme.scripts.logolist = window.theme.scripts.logolist || {};
window.theme.scripts.logolist.init = logolistActions.runLogolist;


  } catch(e) { console.error(e); }
})();
})();
